import {Injectable} from '@angular/core';
import {HttpService} from './http.service';
import {Observable} from 'rxjs';
import {Api} from '../enum/Api';
import {environment} from '../../../environments/environment';

@Injectable()
export class ProductService {
  constructor(private httpService: HttpService) {}

  public getEcommerceUrls(businessId: string, userId: string): Observable<any> {
    return this.httpService.post(
      'eCommercePME/eCommerceAPI/getEcommerceEndpoints',
      Api.One_Portal,
      {
        'businessId': businessId,
        'userId': userId,
        'environment': environment.one_environment
      }
    )
  }

  public isVariableProduct(product: any): boolean {
    const IDENTIFIER_POSSIBLE_VARIABLE_PRODUCT = ["variavel"];
    return product && IDENTIFIER_POSSIBLE_VARIABLE_PRODUCT.some(identifier => product.identifier?.toLowerCase().includes(identifier));
  }
}
